import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_2tg9xPshw5cC: {
	id: 'prd_2tg9x2DEV2Pshw5cC'
	ident: 'prd_2tg9xPshw5cC'
	sku: 'simple_premium_1m_17_99_1m_29_99_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'month'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_6Qu9Y2DEV2GcBxb5Z'
			amount: 29.99
			amount_usd: 17.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 17.99
			discount: 12
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'month'
			interval_duration: 1
			iteration_count: null
			price_id: 'prc_R7b3i2DEV2Hrvn9kz'
			amount: 29.99
			amount_usd: 29.99
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_2tg9xPshw5cC, SubscriptionProduct>
const prd_2tg9xPshw5cC = { ident: 'prd_2tg9xPshw5cC' } as typeof _prd_2tg9xPshw5cC

export default prd_2tg9xPshw5cC
